export default __webpack_public_path__ + "static/media/diba-layanan-siswa.8a396861.png";